/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Payment_Method_Failed_ContentInputs */

const en_dialog_payment_method_failed_content = /** @type {(inputs: Dialog_Payment_Method_Failed_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your payment method may have expired or become unusable. Please update your payment information and try again, or refer to the FAQ.`)
};

const ar_dialog_payment_method_failed_content = /** @type {(inputs: Dialog_Payment_Method_Failed_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قد تكون طريقة الدفع الخاصة بك قد انتهت صلاحيتها أو أصبحت غير صالحة للاستخدام. يرجى تحديث معلومات الدفع الخاصة بك والمحاولة مرة أخرى، أو الرجوع إلى الأسئلة الشائعة.`)
};

const de_dialog_payment_method_failed_content = /** @type {(inputs: Dialog_Payment_Method_Failed_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihre Zahlungsmethode ist möglicherweise abgelaufen oder unbrauchbar geworden. Bitte aktualisieren Sie Ihre Zahlungsinformationen und versuchen Sie es erneut, oder lesen Sie in den FAQ nach.`)
};

const es_dialog_payment_method_failed_content = /** @type {(inputs: Dialog_Payment_Method_Failed_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es posible que tus datos de pago haya caducado o esté inutilizable. Actualiza tus datos de pago e inténtalo de nuevo, o consulta las preguntas frecuentes.`)
};

const fr_dialog_payment_method_failed_content = /** @type {(inputs: Dialog_Payment_Method_Failed_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il se peut que votre méthode de paiement ait expiré ou soit devenue inutilisable. Veuillez mettre à jour vos informations de paiement et réessayez, ou consultez la FAQ.`)
};

const it_dialog_payment_method_failed_content = /** @type {(inputs: Dialog_Payment_Method_Failed_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tuo metodo di pagamento potrebbe essere scaduto o inutilizzabile. Aggiorna le tue informazioni di pagamento e riprova, oppure consulta le FAQ.`)
};

const ja_dialog_payment_method_failed_content = /** @type {(inputs: Dialog_Payment_Method_Failed_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お支払い方法の有効期限が切れているか、使用できなくなっている可能性があります。お支払い情報を更新して再度お試しいただくか、よくある質問をご参照ください。`)
};

const ko_dialog_payment_method_failed_content = /** @type {(inputs: Dialog_Payment_Method_Failed_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`결제 수단이 만료되었거나 사용할 수 없어요. 결제 정보를 업데이트하고 다시 시도하거나 FAQ를 참조하세요.`)
};

const pt_br_dialog_payment_method_failed_content = /** @type {(inputs: Dialog_Payment_Method_Failed_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seu método de pagamento pode ter expirado ou se tornou inutilizável. Atualize seus dados de pagamento e tente novamente ou consulte nossas Perguntas Frequentes.`)
};

const ru_dialog_payment_method_failed_content = /** @type {(inputs: Dialog_Payment_Method_Failed_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Срок действия вашего способа оплаты мог истечь, или он недоступен. Обновите платежную информацию и повторите попытку или обратитесь к часто задаваемым вопросам.`)
};

const th_dialog_payment_method_failed_content = /** @type {(inputs: Dialog_Payment_Method_Failed_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`วิธีการชำระเงินของคุณอาจหมดอายุหรือไม่สามารถใช้งานได้ โปรดอัปเดตข้อมูลการชำระเงินของคุณแล้วลองอีกครั้ง หรือดูคำถามที่พบบ่อย`)
};

const tr_dialog_payment_method_failed_content = /** @type {(inputs: Dialog_Payment_Method_Failed_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ödeme yönteminin süresi dolmuş veya kullanılamaz hale gelmiş olabilir. Lütfen ödeme bilgilerini güncelleyip tekrar dene veya SSS bölümüne göz at.`)
};

const zh_cn_dialog_payment_method_failed_content = /** @type {(inputs: Dialog_Payment_Method_Failed_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的付款方式可能已过期或无法使用，请更新付款信息后重试或参考常见问题。`)
};

const zh_tw_dialog_payment_method_failed_content = /** @type {(inputs: Dialog_Payment_Method_Failed_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的付款方式可能過期或無法使用，請更新付款資訊後重試或參考常見問題。`)
};

/**
* | output |
* | --- |
* | "Your payment method may have expired or become unusable. Please update your payment information and try again, or refer to the FAQ." |
*
* @param {Dialog_Payment_Method_Failed_ContentInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_payment_method_failed_content = /** @type {((inputs?: Dialog_Payment_Method_Failed_ContentInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Payment_Method_Failed_ContentInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_payment_method_failed_content(inputs)
	if (locale === "ar") return ar_dialog_payment_method_failed_content(inputs)
	if (locale === "de") return de_dialog_payment_method_failed_content(inputs)
	if (locale === "es") return es_dialog_payment_method_failed_content(inputs)
	if (locale === "fr") return fr_dialog_payment_method_failed_content(inputs)
	if (locale === "it") return it_dialog_payment_method_failed_content(inputs)
	if (locale === "ja") return ja_dialog_payment_method_failed_content(inputs)
	if (locale === "ko") return ko_dialog_payment_method_failed_content(inputs)
	if (locale === "pt_br") return pt_br_dialog_payment_method_failed_content(inputs)
	if (locale === "ru") return ru_dialog_payment_method_failed_content(inputs)
	if (locale === "th") return th_dialog_payment_method_failed_content(inputs)
	if (locale === "tr") return tr_dialog_payment_method_failed_content(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_payment_method_failed_content(inputs)
	return zh_tw_dialog_payment_method_failed_content(inputs)
});